<template lang="pug">
.observed
  slot
</template>
<script>
export default {
  name: "ObserveComponent",
  setup(){
    const observer = null;
    return {observer};
  },
  created(){
    this.observer = new IntersectionObserver(([entry]) => {
      this.$emit('observe',entry);
    })
  },
  mounted(){
    this.observer?.observe(this.$el);
  },
  unmounted(){
    this.observer?.disconnect();
  }
};
</script>
<style scoped lang="scss">
.observed{
  width:100%;
  min-height:1px;
}
</style>
